import {
  Entitlement,
  IButton,
  IImageWithAlt,
  IKitPrices,
  TColor,
  TImage,
} from 'petdna-lib-uicomponents/hygraph';

import { EErrorCode } from './Errors';

export interface IPopupList {
  id: string;
  popups: {
    id: string;
  }[];
}

export enum EPopupButtonAction {
  UPDATE_PET_LOCATION = 'UPDATE_PET_LOCATION',
  UPDATE_DISPLAYED_USERNAME = 'UPDATE_DISPLAYED_USERNAME',
}

export interface IPopupSimpleContent {
  __typename: EPopupContentType;
  title?: string;
  titleColor?: TColor;
  icon?: TImage;
  imageWithAlt?: IImageWithAlt;
  text?: string;
  textColor?: TColor;
  learnMoreLabel?: string;
  learnMoreLabelColor?: TColor;
  learnMoreLink?: string;
  inputField: boolean;
  inputLabel?: string;
  inputPlaceholder?: string;
  button?: IButton;
  buttonAction?: EPopupButtonAction;
  kitPrice?: IKitPrices;
  closeButton: boolean;
  closeButtonText?: string;
}

export type TPopupContent = IPopupSimpleContent;

export enum EPopupContentType {
  PopupSimpleContent = 'PopupSimpleContent',
}

export enum EPopupSettingType {
  PopupUserSetting = 'PopupUserSetting',
  PopupPetSetting = 'PopupPetSetting',
}

export interface IPopupUserSetting {
  __typename: string;
  id: string;
  name: string;
  showDate: string;
  noSurveyFilled: boolean;
  noDisplayedUsername: boolean;
  saveToStorage: boolean;
}

export interface IPopupPetSetting {
  __typename: string;
  id: string;
  name: string;
  showDate: string;
  petAgeFrom: number | null;
  petAgeTo: number | null;
  entitlements: Entitlement[];
  healthUpgrade: boolean;
  birthdayRelated: boolean;
  breeds: { breedID: string; }[];
  noLocation: boolean;
  saveToStorage: boolean;
}

export interface IErrorSettings {
  __typename: string;
  id: string;
  name: string;
  code: EErrorCode
}

export type TPopupSetting = IPopupUserSetting | IPopupPetSetting | IErrorSettings;

export interface IPopup<T extends TPopupSetting, K extends TPopupContent = TPopupContent> {
  id: string;
  name: string;
  topBorderColor?: TColor;
  content: K;
  active: boolean;
  setting: T;
}

export interface IPopupStorage {
  id: string;
  showDate: number;
  userId: string;
  testGuid?: string;
}

export interface IPopupsStorage {
  popups: IPopupStorage[];
  userId: string | null;
}
